// URL <-> app-state sync so views are deep-linkable: Duplicate Tab, bookmarks,
// pasted links, and right-click "Open in new tab" all reopen the exact view.
// State is kept in the query string: ?country=UK&cat=<category>&m=<YYYY-MM>&view=<id>

export function readUrlState() {
  const p = new URLSearchParams(window.location.search);
  return {
    country:  p.get('country') || null,
    category: p.get('cat')     || null,
    month:    p.get('m')       || '',
    view:     p.get('view')    || null,
  };
}

// True when the URL already carries a view/market — used to skip the landing
// page for a deep link so a cloned tab lands straight on the dashboard.
export function hasDeepLink() {
  const p = new URLSearchParams(window.location.search);
  return p.has('view') || p.has('country') || p.has('cat');
}

export function buildViewSearch({ country, category, month, view } = {}) {
  const p = new URLSearchParams();
  if (country)  p.set('country', country);
  if (category) p.set('cat', category);
  if (month)    p.set('m', month);
  if (view)     p.set('view', view);
  const s = p.toString();
  return s ? `?${s}` : '';
}

// Relative href for anchors (keeps the current path; Firebase Hosting rewrites all
// paths to index.html so any path is fine).
export function buildViewHref(state) {
  return `${window.location.pathname}${buildViewSearch(state)}`;
}

// Update the address bar without adding history entries.
export function writeUrlState(state) {
  window.history.replaceState(null, '', buildViewHref(state));
}
